import { numWordForm } from '@frontend/jetlend-core/src/utils/langUtils';
import React from 'react';
import ProgressBar from '@frontend/jetlend-web-ui/src/ui/ProgressBar/ProgressBar';
import { getEstimatedMinutes } from '@app/features/academy/academy.helper';

import styles from '../CoursesItemCard.module.scss';

interface IProps {
    /**
     * Ссылка на страницу курса
     */
    url: string;
    /**
     * Кол-во блоков в курсе
     */
    blocksCount: number;
    /**
     * Иконка навыка
     */
    videoEstimatedTime?: number;
    /**
     * Иконка навыка
     */
    contentEstimatedTime?: number;
}

/**
 * Компонент отображается, если курс не пройден
 * Отображается информация о длительности курса
 */
const NotPassedCardFooter:React.FC<IProps> = props => {
    const {
        videoEstimatedTime,
        contentEstimatedTime,
        blocksCount,
    } = props;

    return ((videoEstimatedTime || contentEstimatedTime)
        ? (
            <div className={styles['estimated-container']}>
                {videoEstimatedTime && (
                    <div className={styles['estimated-block']}>
                        <span>Видео формат</span>
                        <span>{numWordForm(blocksCount, 'blocks')} ({getEstimatedMinutes(videoEstimatedTime)})</span>
                    </div>
                )}
                {contentEstimatedTime && (
                    <div className={styles['estimated-block']}>
                        <span>Текстовый формат</span>
                        <span>{numWordForm(blocksCount, 'blocks')} ({getEstimatedMinutes(contentEstimatedTime)})</span>
                    </div>
                )}
            </div>
        )
        : (
            <>
                <ProgressBar
                    darkGrey
                    hideLabel
                    type="success"
                    size="small"
                    progress={0}
                />
                <div className={styles['link']}>Начать прохождение</div>
            </>
        ));
};

export default NotPassedCardFooter;
